import { render, staticRenderFns } from "./TeachingDeleteDialog.vue?vue&type=template&id=a14d5260"
import script from "./TeachingDeleteDialog.vue?vue&type=script&lang=js"
export * from "./TeachingDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports